var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('purchasesPayment-form',{attrs:{"loading":_vm.loading,"purchasesPaymentData":_vm.purchasesPayment,"formErrors":_vm.formErrors},on:{"purchasesPaymentSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }